import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import MyApplyCase from './my-apply-case'
import MyApplyCaseDetails from './my-apply-case-details'
import MyApplyCaseModify from './my-apply-case-modify'

export default class ApplyCase extends Component {
    render() {
        return (
            <Switch>
                <Route path='/fixcomputer/applycase' component={MyApplyCase} exact /> {/*exact = 路徑完全匹配*/}
                <Route path='/fixcomputer/applycase/details' component={MyApplyCaseDetails} />
                <Route path='/fixcomputer/applycase/modify' component={MyApplyCaseModify} />
                <Redirect to='/fixcomputer/applycase' />
            </Switch>
        )
    }
}